import cake from "../../../core/assets/icons/cake-lg.svg?raw";
import desserts from "../../../core/assets/icons/desserts.svg?raw";
import sladkaDilna from "../../../core/assets/icons/sladka-dilna.svg?raw";
import type { Step } from "../../../core/schema/Step.js";

export const valentinesSteps: Step[] = [
	{
		title: "Vyberte si valentýnské dobroty",
		description:
			"Prolistujte naši valentýnskou nabídku a vyberte si dortíky, které rozzáří úsměv vaší drahé polovičky.",
		icon: desserts,
	},
	{
		title: "Pečeme s láskou <br>za vás",
		description: "Naše dílna se postará o čerstvé a krásné valentýnské dobroty, připravené s maximální péčí.",
		icon: cake,
	},
	{
		title: "Vyzvedněte a potěšte svou drahou polovičku",
		description: "Stačí si vyzvednout objednávku na vybrané pobočce a užít si nezapomenutelný valentýnský okamžik.",
		icon: sladkaDilna,
	},
];
